var gridEquipmentNode = require('./gridEquipmentNode');
var svgGeometry = require('./svgGeometry');

function parsePositiveNumber(value) {
  var parsed = parseFloat(value);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
}

function parseViewBoxSize(value) {
  if (typeof value !== 'string') return null;
  var parts = value.trim().split(/[\s,]+/).map(Number);
  if (parts.length < 4) return null;
  var width = parts[2];
  var height = parts[3];
  if (Number.isFinite(width) && width > 0 && Number.isFinite(height) && height > 0) {
    return { width: width, height: height };
  }
  return null;
}

function expandBounds(bounds, rect) {
  if (!rect) return bounds;
  var left = Number(rect.x);
  var top = Number(rect.y);
  var right = left + Number(rect.width);
  var bottom = top + Number(rect.height);

  if (![left, top, right, bottom].every(Number.isFinite)) return bounds;
  if (!bounds) {
    return { left: left, top: top, right: right, bottom: bottom };
  }

  return {
    left: Math.min(bounds.left, left),
    top: Math.min(bounds.top, top),
    right: Math.max(bounds.right, right),
    bottom: Math.max(bounds.bottom, bottom)
  };
}

function getGeometrySize(root) {
  if (!root || typeof root.querySelectorAll !== 'function') return null;
  var bounds = null;
  var paths = root.querySelectorAll('path');

  for (var i = 0; i < paths.length; i++) {
    var path = paths[i];
    var data = path.getAttribute('d');
    if (typeof data !== 'string' || data.trim().length === 0) continue;

    var geometry = svgGeometry.parseSvgPathGeometry(data, { context: 'svgGridSizing', silent: true });
    bounds = expandBounds(bounds, svgGeometry.readSafeGeometryBounds(geometry));
  }

  if (!bounds) return null;
  var width = bounds.right - bounds.left;
  var height = bounds.bottom - bounds.top;
  if (Number.isFinite(width) && width > 0 && Number.isFinite(height) && height > 0) {
    return { width: width, height: height };
  }
  return null;
}

function getRootSize(root) {
  if (!root) return null;
  var viewBoxSize = parseViewBoxSize(root.getAttribute('viewBox'));
  if (viewBoxSize) return viewBoxSize;

  var width = parsePositiveNumber(root.getAttribute('width'));
  var height = parsePositiveNumber(root.getAttribute('height'));
  if (width && height) return { width: width, height: height };
  return null;
}

function getSvgPixelSize(svgConverted) {
  var sanitized = typeof svgConverted === 'string' ? svgConverted.trim() : '';
  if (!sanitized || typeof DOMParser === 'undefined') return null;

  try {
    var xmldoc = new DOMParser().parseFromString(sanitized, 'text/xml');
    var root = xmldoc && xmldoc.documentElement;
    return getGeometrySize(root) || getRootSize(root);
  } catch (err) {
    return null;
  }
}

function snapCellCount(pixelSize, cellSize, fallback) {
  var parsed = Number(pixelSize);
  if (Number.isFinite(parsed) && parsed > 0 && Number.isFinite(cellSize) && cellSize > 0) {
    return Math.max(Math.round(parsed / cellSize), 1);
  }
  return Math.max(Math.round(Number(fallback) || 1), 1);
}

function getGridDefaultsForSvg(svgConverted, fallback) {
  var defaults = Object.assign({ cols: 7, rows: 5 }, fallback || {});
  var size = getSvgPixelSize(svgConverted);
  if (!size) return defaults;

  var cellSize = gridEquipmentNode.getResizeCellSize();
  return {
    cols: snapCellCount(size.width, cellSize.width, defaults.cols),
    rows: snapCellCount(size.height, cellSize.height, defaults.rows)
  };
}

function getGridDefaultsForSvgCollection(svgStrings, fallback) {
  var defaults = Object.assign({ cols: 7, rows: 5 }, fallback || {});
  var cellSize = gridEquipmentNode.getResizeCellSize();
  var maxCols = 0;
  var maxRows = 0;

  (svgStrings || []).forEach(function(svgConverted) {
    var size = getSvgPixelSize(svgConverted);
    if (!size) return;
    maxCols = Math.max(maxCols, snapCellCount(size.width, cellSize.width, defaults.cols));
    maxRows = Math.max(maxRows, snapCellCount(size.height, cellSize.height, defaults.rows));
  });

  if (maxCols > 0 && maxRows > 0) {
    return { cols: maxCols, rows: maxRows };
  }
  return defaults;
}

function getGridDefaultsForStaticSvgNode(nodeData, fallback) {
  var svgStrings = [];
  if (nodeData && typeof nodeData.svgConverted === 'string') {
    svgStrings.push(nodeData.svgConverted);
  }
  if (nodeData && Array.isArray(nodeData.staticSvgs)) {
    nodeData.staticSvgs.forEach(function(staticSvg) {
      if (staticSvg && typeof staticSvg.svgConverted === 'string') {
        svgStrings.push(staticSvg.svgConverted);
      }
    });
  }
  return getGridDefaultsForSvgCollection(svgStrings, fallback);
}

module.exports = {
  getGridDefaultsForStaticSvgNode: getGridDefaultsForStaticSvgNode,
  getGridDefaultsForSvg: getGridDefaultsForSvg,
  getGridDefaultsForSvgCollection: getGridDefaultsForSvgCollection,
  getSvgPixelSize: getSvgPixelSize
};
